import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-cart2-icon',
  templateUrl: './shopping-cart2.component.html'
})
export class ShoppingCart2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
